var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.profession)?_c('div',[_c('b',{staticClass:"profession"},[_vm._v(_vm._s(_vm.$t("profilefollower.Profession")))]),_c('hr'),_c('div',{staticClass:"datails"},[_c('span',{staticClass:"mr-auto"},[_vm._v(" "+_vm._s(_vm.profession)+" ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }